import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/(author)/tac-gia/page.tsx");
